export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6401.27c01b04.jpg";